module.exports = __webpack_public_path__ + "img/qb_bg.cf461f3e.svg";